import {
    DATA_SOURCES_UPDATE,
    DATA_SOURCES_FILTER_UPDATE,

    DATA_SOURCES_CANCEL_TOKEN,

    DATA_ACTIVE_PROJECT,
    DATA_PORTFOLIO_FILTER_VALUES,
    DATA_VIEW_STAGED,
    DELETE_ME_INCREMENT_STEP,
    DATA_SELECTED_PROJECTS_VALUE,
    DATA_DATA_DATE, DATA_SOURCES_ALIAS_UPDATE
} from "./dataTypes";

// DS Model
// const dataSource = {
//     uid = int -> used to track cancellations that return prior to cancel
//     data = [],
//     baselines = [],
//     fetching = false,
//     fetched = true,
//     error = null,
//     cancelToken = null,
//     dirty = true
// };

// Filter Model
// const filter = {
//     field: "wbsid",
//     condition: "EQ 2112"
// };

const initialState = {
    viewStaged: false,                                  // Indicates if staged data will be viewed i.e. '{0}Staged'.format(dataSource.source)
    dataSources: [],                                    // Array of datasources and states (fetched, fetching, data, error)
    fields: [],                                         // Full field array from all sources
    aliases: [],                                        // Full alias array from all sources
    filters: [],                                        // Array of applied filters
    previousFilters: [],                                // Filters before an add/remove to include in the isAffected logic

    // TODO: Move to package or include
    // DL in core and move to it's on reducer/context
    dataPortfolioFilterVals: [],
    activeProject: [],
    dataSelectedProjectsVals: [],

    dataDate: null,

    // Batched Requests - Status of individual
    // datasets will be stored in dataSource []
    fetched: false,
    fetching: false,
    cancelToken: null,
    error: null,

    step: 0
};

export default function dataReducer(state = initialState, action) {
    switch (action.type) {
        case DATA_VIEW_STAGED: {
            return {
                ...state,
                viewStaged: action.payload
            };
        }
        case DATA_SOURCES_UPDATE: {
            return {
                ...state,
                dataSources: action.payload
            };
        }
        case DATA_SOURCES_ALIAS_UPDATE: {
            return {
                ...state,
                fields: action.payload.fields,
                aliases: action.payload.aliases
            };
        }
        case DATA_SOURCES_FILTER_UPDATE: {
            return {
                ...state,
                filters: action.payload.filters,
                previousFilters: action.payload.previousFilters
            };
        }
        case DATA_SOURCES_CANCEL_TOKEN: {
            return {
                ...state,
                cancelToken: action.payload
            };
        }
        case DATA_ACTIVE_PROJECT: {
            return {
                ...state,
                activeProject: action.payload
            };
        }
        case DATA_PORTFOLIO_FILTER_VALUES: {
            return {
                ...state,
                dataPortfolioFilterVals: action.payload
            };
        }
        case DATA_SELECTED_PROJECTS_VALUE: {
            return {
                ...state,
                dataSelectedProjectsVals: action.payload
            };
        }
        case DATA_DATA_DATE: {
            return {
                ...state,
                dataDate: action.payload
            }
        }
        case DELETE_ME_INCREMENT_STEP: {
            return {
                ...state,
                step: action.payload
            };
        }
        default:
            return state;
    }
}
